export const setUserType = (type: string) => {
  localStorage.setItem('ej_type', type);
};

export const resetUserType = () => {
  localStorage.removeItem('ej_type');
};

export const getUserType = (): string => localStorage.getItem('ej_type') || 'guest';
